import React from 'react'
import Career from '../Career/Career'
import Footer from '../Footer/Footer'
import Slide from '../Slide/Slide'
import Vision from '../Vision/Vision'

const Homescreen = () => {
  return (
    <div>
        <br />
        <Vision />
        <br />
        <Career />
        <Slide />
        <br />
        <br />
        <Footer />
    </div>
  )
}

export default Homescreen
